/* OO(2026-10-11) OODAY のクーポン（会長・窓口のご指示）

   1) ログインしているお客さまだけ、ページを開いたときに1回クーポンを自動で入れる
   2) カートの引き出し・カートのページに「クーポンコード」の入れ口を付ける
   3) 入っているときは2行で「OODAY 10%OFF が適用されています」「−¥2,420」と出し、
      「外す」もできる

   ★合言葉（クーポンのコード）は layout/theme.liquid の中で
     「ログインしているときだけ」window.ooDayCode に渡しています。
     ログインしていない方のページには合言葉そのものが出ません。
     画面にも合言葉は出しません（会長のご指示）。

   ★日本時間 2026-10-12 23:59 を過ぎたら、OODAY の案内は自動で止まります
     （入れ口そのものは、ほかのクーポンにも使うので残します）。

   ★仕組み（実機で確かめた 2026-10-11）
     入れる  : /discount/<合言葉>?redirect=/cart.js  → カートのJSONが返る
     外す    : /cart/update.js に {"discount": ""} を送る
     効いたか: 入れる前と後で /cart.js の total_discount が増えたかで見る
*/
(function () {
  'use strict';

  var END = new Date('2026-10-12T23:59:59+09:00').getTime();

  var NOTE_OFF = 'OODAY｜10/12(月・祝)まで ログインすると、お会計で自動10%OFF';
  var NOTE_ON = 'OODAY 10%OFF が適用されています';
  var POP = 'OODAY｜10/12(月・祝)まで ログインするだけで、お会計が自動で10%OFF';

  function over() { return Date.now() > END; }
  function isMember() { return window.ooMember === true; }
  function ooCode() { return window.ooDayCode || ''; }

  function yen(cents) {
    return '¥' + Math.round((cents || 0) / 100).toLocaleString('ja-JP');
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function putCode(c) {
    return fetch('/discount/' + encodeURIComponent(c) + '?redirect=/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function dropCode() {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: '' })
    }).then(function (r) { return r.json(); }).catch(function () { return null; });
  }

  /* 自分で入れた合言葉を覚えておきます（画面には出しません・会長のご指示）。
     「外す」を押したあと自動で入れ直さないための目印としてだけ使います。 */
  function saveCode(c) {
    try { sessionStorage.setItem('oo_coupon_typed', c || ''); } catch (e) {}
  }

  /* ---------------------------------------------------------------
     1) ログインしているお客さまに、1回だけ自動で入れる
     --------------------------------------------------------------- */
  function autoApply() {
    if (over() || !isMember() || !ooCode()) return;
    try { if (sessionStorage.getItem('oo_ooday_auto') === '1') return; } catch (e) {}
    try { sessionStorage.setItem('oo_ooday_auto', '1'); } catch (e) {}
    getCart().then(function (c) {
      if (c && c.total_discount > 0) return null;   // すでに何か入っていれば触らない
      return putCode(ooCode());
    }).then(function (res) {
      if (res) paint();
    });
  }

  /* ---------------------------------------------------------------
     2) 言いかたを直す（商品ページの1行・まん中に出る知らせ）
     --------------------------------------------------------------- */
  function words() {
    if (over()) return;
    var n = document.querySelector('.oo-ooday-note:not(.oo-ooday-note--cart)');
    if (n && n.textContent !== NOTE_OFF) n.textContent = NOTE_OFF;
    var p = document.querySelector('.oo-ooday__text');
    if (p && (p.textContent || '').indexOf('ログイン') < 0) p.textContent = POP;
  }

  /* ---------------------------------------------------------------
     3) クーポンの入れ口（カートの引き出し・カートのページ）
     --------------------------------------------------------------- */
  function build() {
    var box = document.createElement('div');
    box.className = 'oo-coupon';
    box.innerHTML =
      '<div class="oo-coupon__row">' +
      '<input type="text" class="oo-coupon__input" placeholder="クーポンコード"' +
      ' autocomplete="off" autocapitalize="characters" spellcheck="false" aria-label="クーポンコード">' +
      '<button type="button" class="oo-coupon__btn">適用</button>' +
      '</div>' +
      '<p class="oo-coupon__msg" role="status"></p>' +
      '<div class="oo-coupon__on" hidden>' +
      '<span class="oo-coupon__on-text"></span>' +
      '<button type="button" class="oo-coupon__off">外す</button>' +
      '</div>';

    var input = box.querySelector('.oo-coupon__input');
    var btn = box.querySelector('.oo-coupon__btn');
    var msg = box.querySelector('.oo-coupon__msg');

    function say(t, bad) {
      msg.textContent = t || '';
      msg.classList.toggle('is-bad', !!bad);
    }

    function go() {
      var c = (input.value || '').trim();
      if (!c) { say('クーポンコードを入れてください', true); return; }
      btn.disabled = true;
      say('確かめています…');
      var before = 0;
      getCart().then(function (c0) {
        before = (c0 && c0.total_discount) || 0;
        return putCode(c);
      }).then(function () {
        return getCart();
      }).then(function (c1) {
        var now = (c1 && c1.total_discount) || 0;
        btn.disabled = false;
        if (now > before) {
          saveCode(c);
          say('クーポンが適用されました（−' + yen(now - before) + '）');
          setTimeout(function () { location.reload(); }, 900);
        } else {
          say('このクーポンコードは、いまのお買いものにはお使いいただけません', true);
        }
      }).catch(function () {
        btn.disabled = false;
        say('うまくいきませんでした。少しあとでもう一度お試しください', true);
      });
    }

    btn.addEventListener('click', go);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); go(); }
    });
    box.querySelector('.oo-coupon__off').addEventListener('click', function () {
      saveCode('');
      try { sessionStorage.setItem('oo_ooday_auto', '1'); } catch (e) {}   // 外したあと自動で戻さない
      dropCode().then(function () { location.reload(); });
    });

    return box;
  }

  /* 「小計」の行のすぐ上に入れます（2026-10-11 に実物で確かめた置き場所）
       カートのページ        … h6.cart__summary-total
       横から出る引き出し    … div.cart-drawer__summary-total  */
  function mountAt(anchor) {
    if (!anchor || !anchor.parentNode) return false;
    if (anchor.parentNode.querySelector('.oo-coupon')) return false;
    anchor.parentNode.insertBefore(build(), anchor);
    return true;
  }

  /* いま入っている値引きを、入れ口の中に出します */
  function paint() {
    var boxes = document.querySelectorAll('.oo-coupon');
    if (!boxes.length) return;
    getCart().then(function (c) {
      var on = c && c.total_discount > 0;
      var amount = on ? yen(c.total_discount) : '';
      boxes.forEach(function (box) {
        var row = box.querySelector('.oo-coupon__row');
        var onBox = box.querySelector('.oo-coupon__on');
        var onText = box.querySelector('.oo-coupon__on-text');
        if (on) {
          /*   2行に分けます（2026-10-11 会長）。
               1行で出していたら「…が適用されています（−」「¥8,910）」のように
               金額の途中で折り返してしまったためです。
               ★合言葉は画面に出しません（会長のご指示）。 */
          onText.innerHTML = '';
          var l1 = document.createElement('span');
          l1.className = 'oo-coupon__on-name';
          l1.textContent = over() ? 'クーポンが適用されています' : NOTE_ON;
          var l2 = document.createElement('span');
          l2.className = 'oo-coupon__on-amt';
          l2.textContent = '−' + amount;
          onText.appendChild(l1);
          onText.appendChild(l2);
          onBox.hidden = false;
          row.hidden = true;
        } else {
          onBox.hidden = true;
          row.hidden = false;
        }
      });
      //   カートの OODAY の1行は、すでに値引きが入っているときは出しません。
      //   上に「OODAY 10%OFF が適用されています／−¥2,420」と出ているので、
      //   下に「ログインすると10%OFF」が並ぶと「結局いくら引かれるの？」と
      //   迷わせてしまうためです（2026-10-11 確認役の指摘）。
      document.querySelectorAll('.oo-ooday-note--cart').forEach(function (n) {
        if (over() || on) { n.style.display = 'none'; return; }
        n.style.display = '';
        n.textContent = NOTE_OFF;
      });
    });
  }

  function mountAll() {
    var done = false;
    document.querySelectorAll('.cart__summary-total, .cart-drawer__summary-total').forEach(function (a) {
      if (mountAt(a)) done = true;
    });
    if (done) paint();
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    words();
    autoApply();
    mountAll();

    //   引き出しは開いたときに初めて見えるので、しばらく見張ります（30秒）
    var tries = 0;
    var timer = setInterval(function () {
      words();
      mountAll();
      tries += 1;
      if (tries >= 60) clearInterval(timer);
    }, 500);

    //   カートの中身が変わったら、値引きの出かたを入れ直します
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (!e.target.closest('.cart-item, [name="updates[]"], [class*="quantity" i], a[href*="/cart"]')) return;
      setTimeout(paint, 1200);
    }, true);
  });
})();